import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Compass, ArrowLeft } from "lucide-react";
import { LEGACY_REDIRECTS } from "@/data/legacyRedirects";

export default function NotFoundPage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  const redirectTo = LEGACY_REDIRECTS[normalizedPath];

  useEffect(() => {
    if (redirectTo) navigate(redirectTo, { replace: true });
  }, [redirectTo, navigate]);

  // Old Wix URL — redirecting to its new home, render nothing while it happens.
  if (redirectTo) return null;

  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex items-center justify-center px-4">
      <Helmet>
        <title>Page Not Found · Xpeditionz NZ</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="text-center max-w-md">
        <Compass size={40} className="text-[var(--brand-primary)] mx-auto mb-6" />
        <p className="font-mono text-xs tracking-[0.25em] uppercase text-white/50 mb-3">404 — Off The Map</p>
        <h1 className="font-display text-3xl md:text-4xl text-white mb-4">This page doesn't exist</h1>
        <p className="text-white/60 mb-8">
          The link you followed may be broken, or the page may have been moved. Head back to the homepage to find what you're after.
        </p>
        <Link to="/" data-testid="not-found-home-link" className="btn-primary inline-flex">
          <ArrowLeft size={14} /> Back to Homepage
        </Link>
      </div>
    </div>
  );
}
